<template>
  <div v-if="loading" class="flex items-center gap-2 min-w-[112px]" style="color: var(--gray-3)">
    <AwIcon name="i-ph-spinner-gap-bold" color="var(--gray-3)" class="animate-spin size-4" />
    {{ title }}
  </div>

  <div v-else-if="list && list.length > 0" class="flex items-center gap-2">
    <AwIcon v-if="icon" :name="icon" color="var(--gray-3)" />

    <LazyAwBadge
      v-for="(item, index) in list.slice(0, maxVisibleItems)"
      :key="`${index}-${(Math.random() * 1000).toFixed(0)}`"
      style="height: 22px"
      :is-removable="isRemovable"
      @remove="list = list?.filter((id) => id !== list?.[index])"
    >
      <div class="flex items-center gap-1">
        <TextEllipsis>
          <slot class="flex items-center gap-1" :item="item"></slot>
        </TextEllipsis>
      </div>
    </LazyAwBadge>

    <AwPopover v-if="list.length > maxVisibleItems">
      <AwBadge
        style="height: 22px"
        :label="`+${list.length - maxVisibleItems}`"
        role="button"
        tabindex="0"
        :aria-label="`Voir les ${list.length - maxVisibleItems} autres éléments`"
        @click.stop
      />
      <template #content>
        <div class="flex flex-wrap gap-2 max-w-80">
          <LazyAwBadge
            v-for="(item, index) in list.slice(maxVisibleItems)"
            :key="`${index}-${(Math.random() * 1000).toFixed(0)}`"
            style="height: 22px"
            :is-removable="isRemovable"
            @remove="list = list?.filter((id) => id !== item)"
          >
            <div class="flex items-center gap-1">
              <TextEllipsis>
                <slot :item="item"></slot>
              </TextEllipsis>
            </div>
          </LazyAwBadge>
        </div>
      </template>
    </AwPopover>
  </div>

  <div v-else class="flex items-center gap-2 min-w-[112px]" style="color: var(--gray-3)">
    <AwIcon v-if="icon" :name="icon" />
    {{ title }}
  </div>
</template>

<script setup lang="ts" generic="T">
const list = defineModel<T[]>("list");

withDefaults(
  defineProps<{
    icon?: string;
    maxVisibleItems?: number;
    loading?: boolean;
    title?: string;
    isRemovable?: boolean;
  }>(),
  {
    icon: undefined,
    maxVisibleItems: 1,
    loading: false,
    title: "Item title",
    isRemovable: true,
  }
);
</script>

<style scoped lang=""></style>
